import LabProductsV2 from "./v2/LabProducts";

export default function LabProducts(props) {
  return <LabProductsV2 {...props} />;
}
